import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IPtExceptionReport, IPtListReport } from "app/models/core/admin/ptReports";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";


@Component({
  selector: 'app-ptReports',
  templateUrl: './ptReports.component.html'
})

export class PtReportsComponent implements OnInit {

  list: IPtListReport[] = [];
  list2: IPtExceptionReport[] = [];
  displayedColumns: string[] = ['evaluator', 'exceptionId', 'errorMessage'];
  displayedColumns2: string[] = ['view', 'evaluator', 'ptType', 'dateCreated'];

  dataSource = new MatTableDataSource<IPtListReport>(this.list);
  dataSource2 = new MatTableDataSource<IPtExceptionReport>(this.list2);

  listFilter = '';
  listFilter2 = '';

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;
  @ViewChild('TablePaginator') paginator2: MatPaginator;
  @ViewChild('TableSort') sort2: MatSort;

  selectedItem: IPtListReport;
  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    private datePipe: DatePipe) { };

  ngOnInit() {
    this.loadLists();
  }

  loadLists() {
    this.adminService.getExceptionMasterList().subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.timeout();
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  loadExceptions(item: IPtListReport){
    this.selectedItem = item;
    this.adminService.getPtExceptionReports(this.selectedItem.exceptionId.toString()).subscribe(
      res => {
        this.list = res;
        this.dataSource2.data = this.list2;
        this.timeout2();
      },
      error => console.log('error: ', error),
      () => {
      }
    );    
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  filterTable2(evnt: Event) {
    this.listFilter2 = (evnt.target as HTMLInputElement).value;
    this.dataSource2.filter = this.listFilter2.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  clearFilter2() {
    this.listFilter2 = "";
    this.dataSource2.filter = this.listFilter2;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  getPageSizeOptions2(): number[] {
    if (this.dataSource2.data.length > 20) {
      return [10, 20, this.dataSource2.data.length];
    } else {
      return [10, 20];
    }
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 100);
  }

  timeout2() {
    setTimeout(() => {
      this.dataSource2.paginator = this.paginator2;
      this.dataSource2.sort = this.sort2;
    }, 100);
  }

  print() {
    //TODO
  }

}